import React from 'react';
const Custom = ({ data }) => {
    return React.createElement("pre", null, JSON.stringify(data));
};
export default Custom;
//# sourceMappingURL=Custom.js.map